// extracted by mini-css-extract-plugin
export default {"btn-close":"Dialog_btn-close__sCOUt"};